import { observer } from 'mobx-react-lite'
import env from './../../../../environments/environment'
import React, { useState } from 'react'
import {
  MDBCollapse,
  MDBBtn,
  MDBSelect,
  MDBIcon,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardHeader,
  MDBCardBody,
} from 'mdb-react-ui-kit'
import CustomSwitch from '../../../../components/shared/CustomSwitch/CustomSwitch.component'
import { UIInput } from './../../../../components/forms/form-fields'
import CarrierMgmtStore from './../../CarrierMgmt.store'
import { b64toBlob } from './../../../../shared/utilities/b64toBlob.function'
import CarrierService from './../../../../shared/services/Carrier.service'
import ConfirmDeleteModalComponent from '../../../../components/adminShared/ConfirmDeleteModal/ConfirmDeleteModal.component'
import { toast } from 'react-toastify'

import './CarrierDetailsForm.scss'
import MDB4FileInput from '../../../../components/forms/MDB4FileInput'

const CarrierDetailsForm = ({ table }) => {
  const [activeModal, setActiveModal] = useState(false)

  const onChange = event => {
    if (`${CarrierMgmtStore.carrier[event.target.name]}` !== `${event.target.value}`)
      CarrierMgmtStore.carrier[event.target.name] = event.target.value
  }

  const activeCarrier = active => {
    setActiveModal(false)
    active ? (CarrierMgmtStore.carrier.c_active = 0) : (CarrierMgmtStore.carrier.c_active = 1)
  }

  const onSelectFile = (file, source) => {
    const carrier = CarrierMgmtStore.getCarrier()
    if (!carrier?.id) return

    const reader = new FileReader()

    reader.addEventListener('load', async () => {
      carrier[`${source}_src`] = { filename: file?.name, data: reader.result }

      // Extract content-type from complete base64 payload.
      let match = carrier[`${source}_src`].data.split(',')[0].match(/\w+\/\w+/)
      match = match && match.shift()

      // Extract raw base64 data w/out content-type.
      let base64 = carrier[`${source}_src`].data.split(',')[1]

      // Build payload to send file to the server.
      const formData = new FormData()
      formData.append(source, b64toBlob(base64, match))
      formData.append(`${source}_filename`, file.name)
      formData.append(`${source}_id`, carrier.id)

      try {
        await CarrierService.uploadLogo(CarrierMgmtStore.carrier?.id, formData)
        CarrierService.get(carrier.id).then(res => (CarrierMgmtStore.carrier.c_img = res && res?.c_img))
      } catch (ex) {
        console.error('Failed to upload: ', ex)
      }
    })

    reader.readAsDataURL(file)
  }

  const onSubmit = async event => {
    event.preventDefault()
    if (await CarrierMgmtStore.saveCarrier()) {
      toast.success('Carrier updated successfully', {
        position: toast.POSITION.TOP_RIGHT,
      })
    } else {
      toast.error('Failed to save carrier!', {
        position: toast.POSITION.TOP_RIGHT,
      })
    }
  }

  const deleteLogoImg = async () => {
    await CarrierMgmtStore.saveCarrier({
      id: CarrierMgmtStore.carrier.id,
      c_img: '',
    })
    CarrierMgmtStore.carrier.c_img = null
  }

  const renderFileUploader = () => {
    let carrier = CarrierMgmtStore.getCarrier(),
      cImgPath = carrier && carrier?.c_img ? `${carrier?.c_img}`.trim() : false

    return (
      <div className='img-wrapper'>
        <small>Carrier Logo</small>
        {cImgPath ? (
          <>
            <div onClick={deleteLogoImg} className='delete-btn'>
              <MDBIcon icon='trash' className='remove' />
            </div>
            <div className='img'>
              <img
                src={`https://firebasestorage.googleapis.com/v0/b/${
                  env.integrations.firebase.config.storageBucket
                }/o/${encodeURIComponent(cImgPath)}?alt=media`}
                alt='Carrier Logo'
              />
            </div>
          </>
        ) : (
          <></>
        )}
        <MDB4FileInput
          disabled={!carrier?.id}
          name='c_img'
          accept='image/*'
          getValue={value => onSelectFile(value[0], 'c_img')}
        />
      </div>
    )
  }

  const renderLoadingWheel = () => {
    if (CarrierMgmtStore.getIsLoading('fetch.carrier') || CarrierMgmtStore.getIsLoading('update.carrier'))
      return (
        <span>
          <i className='fa fa-spin fa-spinner' />
        </span>
      )
  }

  return (
    <MDBCard id='CarrierDetailsFormComponent'>
      <div className='confirm-delete-button'>
        {activeModal ? (
          <ConfirmDeleteModalComponent
            confirm={
              <>
                {CarrierMgmtStore.carrier?.c_name || ''}
                <br />
                {CarrierMgmtStore.carrier?.c_description || ''}
              </>
            }
            onCancel={() => activeCarrier(false)}
            onConfirm={() => activeCarrier(true)}
            isDeactivate={true}
          />
        ) : (
          <></>
        )}
      </div>
      <MDBCardHeader>
        Carrier Profile
        {renderLoadingWheel()}
      </MDBCardHeader>
      <MDBCardBody>
        <form noValidate onSubmit={onSubmit}>
          <MDBRow>
            <MDBCol size='12'>
              <UIInput
                label='Carrier Name'
                type='text'
                name='c_name'
                value={CarrierMgmtStore.carrier?.c_name || ''}
                onChange={onChange}
                autoComplete='off'
              />
            </MDBCol>
            <MDBCol size='12'>
              <UIInput
                label='Carrier Description'
                type='textarea'
                name='c_description'
                value={CarrierMgmtStore.carrier?.c_description || ''}
                onChange={onChange}
              />
            </MDBCol>
            <MDBCol size='4'>
              <MDBSelect
                data={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(i => ({
                  text: `${i}`,
                  value: `${i}`,
                  ...(`${i}` === `${CarrierMgmtStore.carrier?.c_term_length}` ? { selected: true } : {}),
                }))}
                label='Default Term Length'
                name='c_term_length'
                value={
                  CarrierMgmtStore.carrier?.c_term_length != null ? `${CarrierMgmtStore.carrier.c_term_length}` : ''
                }
                preventFirstSelection
                onValueChange={val => {
                  const e = (Array.isArray(val) ? val[0] : val)?.value
                  if (e != null && `${CarrierMgmtStore.carrier?.c_term_length}` !== `${e}`)
                    CarrierMgmtStore.carrier.c_term_length = e
                }}
              />
            </MDBCol>
            <MDBCol size='4'>
              <MDBSelect
                data={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(i => ({
                  text: `${i}`,
                  value: `${i}`,
                  ...(`${i}` === `${CarrierMgmtStore.carrier?.c_term_length_min}` ? { selected: true } : {}),
                }))}
                label='Min Term Length'
                name='c_term_length_min'
                value={
                  CarrierMgmtStore.carrier?.c_term_length_min != null
                    ? `${CarrierMgmtStore.carrier.c_term_length_min}`
                    : ''
                }
                preventFirstSelection
                onValueChange={val => {
                  const e = (Array.isArray(val) ? val[0] : val)?.value
                  if (e != null && `${CarrierMgmtStore.carrier?.c_term_length_min}` !== `${e}`)
                    CarrierMgmtStore.carrier.c_term_length_min = e
                }}
              />
            </MDBCol>
            <MDBCol size='4'>
              <MDBSelect
                data={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(i => ({
                  text: `${i}`,
                  value: `${i}`,
                  ...(`${i}` === `${CarrierMgmtStore.carrier?.c_term_length_max}` ? { selected: true } : {}),
                }))}
                label='Max Term Length'
                name='c_term_length_max'
                value={
                  CarrierMgmtStore.carrier?.c_term_length_max != null
                    ? `${CarrierMgmtStore.carrier.c_term_length_max}`
                    : ''
                }
                preventFirstSelection
                onValueChange={val => {
                  const e = (Array.isArray(val) ? val[0] : val)?.value
                  if (e != null && `${CarrierMgmtStore.carrier?.c_term_length_max}` !== `${e}`)
                    CarrierMgmtStore.carrier.c_term_length_max = e
                }}
              />
            </MDBCol>
            <MDBCol size='12'>
              <UIInput
                label='Carrier Website'
                type='text'
                name='c_website'
                value={CarrierMgmtStore.carrier?.c_website || ''}
                onChange={onChange}
                autoComplete='off'
              />
            </MDBCol>
            <MDBCol size='12' className={CarrierMgmtStore.carrier?.fmo_id > 0 ? 'carrier-selected' : ''}>
              <MDBSelect
                key={CarrierMgmtStore.carrier?.fmo_id ? 'fmo-set' : 'fmo-none'}
                data={(CarrierMgmtStore.fmos || []).map(i => ({
                  text: `${i.fmo_name}`,
                  value: `${i.id}`,
                  ...(`${i.id}` === `${CarrierMgmtStore.carrier?.fmo_id}` ? { selected: true } : {}),
                }))}
                label='Select Carrier FMO'
                name='fmo_id'
                value={CarrierMgmtStore.carrier?.fmo_id != null ? `${CarrierMgmtStore.carrier.fmo_id}` : ''}
                preventFirstSelection
                onValueChange={val => {
                  const e = (Array.isArray(val) ? val[0] : val)?.value
                  if (e != null && `${CarrierMgmtStore.carrier?.fmo_id}` !== `${e}`) CarrierMgmtStore.carrier.fmo_id = e
                }}
              />
              <div className='fmo-remove-btn'>
                <button onClick={() => (CarrierMgmtStore.carrier.fmo_id = null)}>
                  <MDBIcon icon='trash' className='remove red-text' />
                </button>
              </div>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol size='12'>
              <MDBCollapse open={!!(CarrierMgmtStore.getCarrier()?.id > 0)}>{renderFileUploader()}</MDBCollapse>
            </MDBCol>
            <MDBCol size='12' sm='6' lg='4' className='carrier-detail-toggle'>
              <CustomSwitch
                labelLeft={
                  <>
                    Carrier
                    <br />
                    Is Active?
                  </>
                }
                labelRight={''}
                name='c_active'
                checked={`${CarrierMgmtStore.carrier?.c_active}` === '1'}
                onChange={() =>
                  `${CarrierMgmtStore.carrier?.c_active}` === '1' ? setActiveModal(!activeModal) : activeCarrier(false)
                }
              />
            </MDBCol>
            <MDBCol size='12' sm='6' lg='4' className='carrier-detail-toggle'>
              <CustomSwitch
                labelLeft={
                  <>
                    Show Logo
                    <br />
                    on Homepage?
                  </>
                }
                labelRight={''}
                name='show_public_logo'
                checked={`${CarrierMgmtStore.carrier?.show_public_logo}` === '1' ? true : false}
                onChange={event =>
                  (CarrierMgmtStore.carrier.show_public_logo =
                    `${CarrierMgmtStore.carrier?.show_public_logo}` === '1' ? 0 : 1)
                }
              />
            </MDBCol>
          </MDBRow>
          <MDBRow className='mt-1 pt-3'>
            <MDBCol size='12' sm='6' lg='4' className='carrier-detail-toggle'>
              <CustomSwitch
                labelLeft={
                  <>
                    Requires
                    <br />
                    MedAdv?
                  </>
                }
                labelRight={''}
                name='requires_med_adv'
                checked={`${CarrierMgmtStore.carrier?.requires_med_adv}` === '1'}
                onChange={e => (CarrierMgmtStore.carrier.requires_med_adv = e.target.value ? 1 : 0)}
              />
            </MDBCol>
            <MDBCol size='12' sm='6' lg='4' className='carrier-detail-toggle'>
              <CustomSwitch
                labelLeft={
                  <>
                    Requires
                    <br />
                    FFM?
                  </>
                }
                labelRight={''}
                name='requires_ffm'
                checked={`${CarrierMgmtStore.carrier?.requires_ffm}` === '1'}
                onChange={e => (CarrierMgmtStore.carrier.requires_ffm = e.target.value ? 1 : 0)}
              />
            </MDBCol>
            <MDBCol size='12' sm='6' lg='4' className='carrier-detail-toggle'>
              <CustomSwitch
                labelLeft={
                  <>
                    Requires
                    <br />
                    AML?
                  </>
                }
                labelRight={''}
                name='requires_aml'
                checked={`${CarrierMgmtStore.carrier?.requires_aml}` === '1'}
                onChange={e => (CarrierMgmtStore.carrier.requires_aml = e.target.value ? 1 : 0)}
              />
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol size='12'>
              <MDBBtn
                color='default'
                className='btn-block'
                type='submit'
                disabled={
                  !CarrierMgmtStore.carrier?.c_name ||
                  (!CarrierMgmtStore.carrier?.contract_email && `${CarrierMgmtStore.carrier?.is_automated}` === '1')
                }
              >
                {CarrierMgmtStore.getIsLoading('update.carrier') ? (
                  <span>
                    Saving...&nbsp;
                    <i className='fa fa-spin fa-spinner' />
                  </span>
                ) : (
                  <>
                    Save Carrier&nbsp;
                    <MDBIcon icon='save' />
                  </>
                )}
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        </form>
      </MDBCardBody>
    </MDBCard>
  )
}

export default observer(CarrierDetailsForm)
